import React, { useEffect, useState, useRef } from 'react';
import TextEditor from '../../../../../../../Components/TextEditor';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { setFeedsFirstLoad, setFeedsHasMore, setFeedsLoading, setFeedsPage, setFeedsShowLoader, setSelectedPath } from '../../../../../../../slices/feeds/reducer';
import { setSelectPathModalKind, toggleFeedConnectionLoader, toggleFeedConnectionModal, toggleSelectPathLoader, toggleSelectPathModal, toggleTargetUrlModal } from '../../../../../../../slices/modals/reducer';
import { getFeedInfo, getFeeds } from '../../../../../../../slices/feeds/thunk';
import { setActiveDynamicText, setDynamicText, setSelectedTag } from '../../../../../../../slices/campaigns/reducer';
import { isJsonPath } from '../../../../../../../slices/campaigns/helper';
import ComponentShowerHook from '../../../../../../../Components/Hooks/ComponentShowerHook';
import { highlightDynamicTexts, removeHighlightDynamicTexts, setAllCreativesFont, setCreativesDynamicText, setDynamicTextTag } from '../../../../../../../slices/campaigns/thunk';

function DynamicText({ item }) {
  const dispatch = useDispatch();
  const { ref, isComponentVisible, setIsComponentVisible } = ComponentShowerHook(false);

  const stateSelect = createSelector(state => state, state => ({
    currentVersion: state.Campaign.currentVersion,
    dynamicText: state.Campaign.dynamicText,
    activeDynamicText: state.Campaign.activeDynamicText,
    connectedFeed: state.Campaign.connectedFeed,
    selectedCreative: state.Campaign.selectedCreative,
    creatives: state.Campaign.creatives
  }));
  const { currentVersion, dynamicText, activeDynamicText, connectedFeed, selectedCreative, creatives } = useSelector(stateSelect);
  const [value, setValue] = useState('');
  const [previousVal, setPreviousVal] = useState('');
  const [inputChanged, setInputChanged] = useState('');
  const [isGlobal, setIsGlobal] = useState(false);
  const textBoxRef = useRef(null);

  useEffect(() => {
    if (activeDynamicText.isCreative) {
      setIsGlobal(false);
    } else {
      setIsGlobal(true);
    }
  }, [activeDynamicText]);


  useEffect(() => {
    if (item.isFeed && connectedFeed) {
      const foundFeedVal = connectedFeed.find(feedItem => feedItem.path === item.value);
      if (foundFeedVal && foundFeedVal.values) {
        setValue(foundFeedVal.values[0]);
        textBoxRef.current.innerHTML = foundFeedVal.values[0];
      } else {
        setValue(item.value);
        textBoxRef.current.innerHTML = item.value;
      }
    } else {
      setPreviousVal(item.value);
      setValue(item.value);
      textBoxRef.current.innerHTML = item.value;
    }
  }, [item]);
  // Create or Update Dynamic Text Item
  useEffect(() => {
    if (!item.isFeed && inputChanged) {
      if (selectedCreative) {
        if (dynamicText.find(item => (item.isCreative === true) && (item.creativeId === selectedCreative._id))) {
          dispatch(setDynamicTextTag({ ...item, value: value }));
        } else {
          if (value !== previousVal) {
            const newTexts = [];
            dynamicText[0].texts.forEach(dItem => {
              if (dItem.tag === item.tag) {
                newTexts.push({ ...dItem, value: value });
              } else {
                newTexts.push(dItem);
              }
            });
            const newDynamicTextObj = { ...dynamicText[0], texts: newTexts, isCreative: true, creativeId: selectedCreative?._id };
            delete newDynamicTextObj._id;
            delete newDynamicTextObj.id;
            dispatch(setDynamicText([...dynamicText, newDynamicTextObj]));
            // dispatch(setActiveDynamicText(null));
            // setTimeout(() => {
            dispatch(setActiveDynamicText(newDynamicTextObj));
            // }, 1);
          }
        }
      } else {
        dispatch(setDynamicTextTag({ ...item, value: value }));
      }
      dispatch(setCreativesDynamicText(item));
      // dispatch(setAllCreativesFont());
    }
  }, [inputChanged]);

  const handleInput = () => {
    const div = textBoxRef.current;
    if (div) {
      removeSpanAndStyles(div);
    }
  };

  const removeSpanAndStyles = (element) => {
    const spans = element.querySelectorAll("span");
    spans.forEach((span) => {
      const parent = span.parentNode;
      while (span.firstChild) {
        parent.insertBefore(span.firstChild, span);
      }
      parent.removeChild(span);
    });
    setValue(prevState => {
      setPreviousVal(prevState);
      return textBoxRef.current.innerHTML.replaceAll('<div>', '</br>').replaceAll('</div>', '');
    });
    setInputChanged(textBoxRef.current.innerHTML.replaceAll('<div>', '</br>').replaceAll('</div>', ''));
    // setTimeout(() => {
    //   const range = document.createRange();
    //   const selection = window.getSelection();

    //   // Set the cursor to the end of the text content
    //   range.selectNodeContents(textBoxRef.current);
    //   range.collapse(false); // Move the cursor to the end
    //   selection.removeAllRanges();
    //   selection.addRange(range);
    // }, 1);
  };

  async function showFeedBindModal() {
    if (currentVersion.hasOwnProperty("feeds") && Array.isArray(currentVersion.feeds)) {
      dispatch(setSelectPathModalKind('dynamicText'));
      dispatch(setSelectedTag(item));
      if (item.isFeed && connectedFeed) {
        const foundFeed = connectedFeed.find(feed => feed.path === item.value);
        if (foundFeed) {
          dispatch(setSelectedPath(foundFeed));
        }
      } else {
        dispatch(setSelectedPath(null));
      }
      dispatch(toggleSelectPathModal());
    } else {
      dispatch(toggleFeedConnectionModal());
      dispatch(toggleFeedConnectionLoader());
      dispatch(setFeedsPage(1));
      dispatch(setFeedsLoading(false));
      dispatch(setFeedsShowLoader(false));
      dispatch(setFeedsHasMore(true));
      dispatch(setFeedsFirstLoad(false));
      await dispatch(getFeeds());
      dispatch(toggleFeedConnectionLoader());
    }
  }

  async function showTargetUrlModal() {
    dispatch(setSelectedTag(item));
    dispatch(toggleTargetUrlModal());
  }


  // Highlight Preview DOM
  function highlightElement(e) {
    setIsComponentVisible(true);
    dispatch(highlightDynamicTexts(item));
  }

  useEffect(() => {
    if (isComponentVisible === false) {
      dispatch(removeHighlightDynamicTexts());
    }
  }, [isComponentVisible]);

  return (
    <div className={isComponentVisible ? 'selected-dynamic-item dynamic-item' : 'dynamic-item'} ref={ref}>
      <div className='d-flex flex-row align-items-center justify-content-between mb-1'>
        <i className='ri-font-size-2 fw-bold me-1'></i>
        <span className='w-100 text-truncate me-2'>
          {item.name}
        </span>
        <div className='d-flex align-items-center gap-1'>
          <button
            className={'btn btn-icon btn-sm ' + (item.isFeed ? ' btn-info' : ' btn-soft-dark')}
            style={{ position: 'relative', zIndex: '0' }}
            onClick={showFeedBindModal}
          >
            <i className='mdi mdi-rss'></i>
          </button>
          <button
            className={'btn btn-icon btn-sm ' + (item.hasOwnProperty('targetUrl') && item.targetUrl && item.targetUrl !== '' && item.targetUrl !== ' ' ? 'btn-primary' : 'btn-soft-dark')}
            style={{ position: 'relative', zIndex: '0' }}
            onClick={showTargetUrlModal}>
            <i className='mdi mdi-link'></i>
          </button>
        </div>
      </div>
      <div className='form-control p-0 rounded'>
        <div className='w-100 h-100 py-1 px-2'
          style={{ minHeight: '100px', resize: 'vertical', overflow: 'auto', textAlign: "left", }}
          ref={textBoxRef}
          contentEditable={item.isFeed ? false : true}
          onInput={(e) => handleInput(e)}
          onClick={highlightElement}
        ></div>
      </div>
      {isGlobal ? item?.dynamicTextIdx !== 0 && item?.dynamicTextSizes && item?.dynamicTextSizes.length > 0 ?
        <div className='d-flex align-items-center w-100 mt-2 mb-1'>
          {item?.dynamicTextSizes.map((size, idx) => {
            return (
              <span className='badge rounded-pill bg-primary-subtle text-primary me-2' key={idx}>{size}</span>
            )
          })}
        </div>
        : null : null}
      {/* <TextEditor
        tag={item.tag}
        value={item.value}
        isFeed={item.isFeed}
        style={item.style}
        isComponentVisible={isComponentVisible}
        setIsComponentVisible={setIsComponentVisible}
        selectedCreative={selectedCreative}
      /> */}

    </div>
  )
}

export default DynamicText
